import { useLocation } from 'react-router-dom';
import routes from '../routes';

const findRoute = (routesList, pathname) => {
  for (const route of routesList) {
    if (route.layout && route.path && `${route.layout}${route.path}` === pathname) {
      return route;
    }
    if (route.items?.length) {
      const nested = findRoute(route.items, pathname);
      if (nested) return nested;
    }
  }
  return null;
};

export const useAdminRouteMeta = () => {
  const { pathname } = useLocation();
  return findRoute(routes, pathname) || {};
};

export default useAdminRouteMeta;
